<template>
  <v-row class="filial-card" :style="blockBtn ? '' : 'border: none'">
    <v-col>
      <div class="filial-card-first-half">
        <v-icon size="20" color="white" :theme="`${icon.color}`" class="status__icon">{{ icon.name }}</v-icon>
        <div class="d-flex flex-column align-start justify-center">
          <div>{{ value.nameFull }}</div>
          <div class="subtitle-text">{{ value.nameShort }}</div>
        </div>
      </div>
    </v-col>
    <v-col>
      <div class="filial-card-second-half">
        <div class="d-flex flex-column align-start justify-center">
          <div><span class="subtitle-text">Адрес:</span> {{ value.address }}</div>
          <div><span class="subtitle-text">КПП</span> {{ value.kpp }}</div>
        </div>
        <div class="d-flex flex-column  justify-center">
          <v-btn
            v-if="btnStatus === 'create' || btnStatus === 'update'"
            class="white__v-btn mb-2" :disabled="blockBtn" @click="$emit('delete', value)"
          >
            {{ btnStatus === 'create' ? 'Отменить добавление' : 'Отменить редактирование' }}
          </v-btn>
          <v-btn
            v-if="btnStatus === 'default' && value.org"
            class="white__v-btn mb-2" :disabled="blockBtn" @click="$emit('change', value)"
          >
            Редактировать
          </v-btn>
          <div v-if="value.org">
            <v-btn
              v-if="btnStatus === 'default'"
              class="error__v-btn" :disabled="blockBtn" :loading="deleting" @click="liquidationConfirm = true"
            >
              Ликвидировать
            </v-btn>
            <v-btn
              v-else-if="btnStatus === 'delete'"
              class="error__v-btn" :disabled="blockBtn" :loading="deleting" @click="$emit('delete', value)"
            >
              Отменить ликвидацию
            </v-btn>
          </div>
        </div>
      </div>
    </v-col>
    <v-dialog v-model="liquidationConfirm" width="1220">
      <v-card>
        <v-card-title style="word-break: break-word;">
          Данное действие уберет филиал из списка филиалов здесь и в формах показателей (в том числе в печати) и не
          будет возможности подать на него предложения по КЦП. Показатели этого филиала не будут учитываться в расчете.
        </v-card-title>
        <v-card-actions style="justify-content: space-evenly">
          <v-btn class="error__v-btn pr-3" @click="$emit('delete', value)">Ликвидировать</v-btn>
          <v-btn class="blue__v-btn pl-3" @click="liquidationConfirm = false">Отменить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import {setFileFunctions} from "@/mixins/fileFucntions";

export default {
  name: "FilialCard",
  mixins: [setFileFunctions],
  props: {
    value: {
      type: Object,
      default: () => ({
        id: 1,
        name: '',
        nameShort: '',
        address: '',
        kpp: '',
        status: 'IN_PROGRESS' | 'CANCELED'
      })
    },
    deleting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      liquidationConfirm: false
    }
  },
  computed: {
    ...mapGetters('checkFilled', {currentStage: 'currentStage'}),
    icon() {
      switch (this.value?.status) {
        case 'IN_PROGRESS':
          return {name: 'mdi-check', color: 'warning'}
        case 'CANCELED':
          return {name: 'mdi-close', color: 'error'}
        default:
          return {name: 'mdi-check', color: 'success'}
      }
    },
    btnStatus() {
      if (this.value.appealType?.slice(11, 17) === 'CREATE') {
        return 'create'
      } else if (this.value.appealType?.slice(11, 17) === 'UPDATE') {
        return 'update'
      } else if (this.value.appealType?.slice(11, 17) === 'DELETE') {
        return 'delete'
      } else {
        return 'default'
      }
    },
    blockBtn() {
      if (this.getAuthData?.realm_access?.roles?.includes('ADMIN_ROLE')) {
        return false
      } else if (this.currentStage === 5 || this.blocked) {
        return true
      } else {
        return false
      }
    }
  },
}
</script>
